import { idEq } from "./functionalUtils"


export const SEAT_RADIUS = 13
export const SEAT_TEMPLATE_EXPANDED_WIDTH = 182
export const SEAT_TEMPLATE_EXPANDED_HEIGHT = 80
export const SEAT_TEMPLATE_EXPANDED_TEXT_MAXWIDTH = 130

export const SeatStatuses = {
    EMPTY: 1,
    RESERVED: 2,
    SOLD: 3,
    RESERVED_BY_ORGANIZER: 4,
    OCCUPIED: 5,
    TABLE: 6,
    DONT_SHOW: 7,
    PLACEHOLDER: 8,
    RESERVED_BY_ORGANIZER_ME: 9,
    RESERVED_ME: 11,
}

export const getSeatStatusColor = status => {
    const reservedColor = "#ff6633"
    const reservedByOrganizerColor = "#d9d9d9"
    const occupiedColor = "#b5925b"
    const seatStatusToColor = {
        [SeatStatuses.EMPTY]: "#8c8c8c",

        [SeatStatuses.RESERVED]: "#d9d9d9",
        [SeatStatuses.RESERVED_ME]: reservedColor,

        [SeatStatuses.SOLD]: "#d9d9d9",

        [SeatStatuses.RESERVED_BY_ORGANIZER]: reservedByOrganizerColor,
        [SeatStatuses.RESERVED_BY_ORGANIZER_ME]: reservedByOrganizerColor,

        [SeatStatuses.OCCUPIED]: occupiedColor,
        [SeatStatuses.DONT_SHOW]: occupiedColor,
        [SeatStatuses.PLACEHOLDER]: occupiedColor,

        [SeatStatuses.TABLE]: "#c7af8a",
    }

    return seatStatusToColor[status] ?? "#212121"
}

export const getSeatsBounds = (seats, margin = 0) => {
    const seatsXs = seats.map(seat => seat.x)
    const seatsYs = seats.map(seat => seat.y)
    return {
        left: Math.min(...seatsXs) - margin,
        top: Math.min(...seatsYs) - margin,
        right: Math.max(...seatsXs) + margin,
        bottom: Math.max(...seatsYs) + margin,
    }
}

export const translateSeats = (seats, translation) =>
    seats.map(seat => ({
        ...seat,
        x: seat.x + translation.x,
        y: seat.y + translation.y,
    }))

export const transformSeats = (seats, matrix) => {
    const seatsBounds = getSeatsBounds(seats, SEAT_RADIUS)
    const centerX = (seatsBounds.right + seatsBounds.left) / 2
    const centerY = (seatsBounds.bottom + seatsBounds.top) / 2

    return seats.map(seat => {
        const x = seat.x - centerX
        const y = seat.y - centerY

        const transformedX = x * matrix.a + y * matrix.b
        const transformedY = x * matrix.c + y * matrix.d

        return {
            ...seat,
            x: Math.round(transformedX + centerX),
            y: Math.round(transformedY + centerY),
        }
    })
}

export const getSeatTitle = ({
    rowNameText,
    seatText,
    statusText,
    ticketTypesText,
    seatStatuses = [],
    rowId,
    rows,
    status,
    name,
    ticketTypes
}) => {

    let seatTitle = `${seatText}
-${rowNameText}: ${rows.find(idEq(rowId)).name}
-${seatText}: ${name}
-${statusText}: ${seatStatuses.find(idEq(status))?.description ?? status}
`

    if (ticketTypes?.length) {
        seatTitle += `-${ticketTypesText}:` +
            ticketTypes.map(ticketType => {
                const name = ticketType.info?.[0]?.name || "";
                return `\n • ${name}`;
            }).join("");
    }

    return seatTitle
}

export const getExpandedSeatTitle = ({
    t,
    seatStatuses = [],
    rowId,
    rows,
    status,
    name,
    ticketTypeName,
    functionName,
    company
}) => {
    let seatTitle = `${t("Seat")}
-${t("TicketType")}: ${ticketTypeName}
-${t("Function")}: ${functionName}
-${t("Company")}: ${company}
-${t("RowName")}: ${rows.find(idEq(rowId)).name}
-${t("Seat")}: ${name}
-${t("Status")}: ${seatStatuses.find(idEq(status))?.description ?? status}
`

    return seatTitle
}

export const getRectCoords = ({ x, y, width, height }) => [
    { x, y },
    {
        x: x + width,
        y: y + height,
    },
]